import { render, staticRenderFns } from "./ConsignmentEdit.vue?vue&type=template&id=2415cfa6&scoped=true&"
import script from "./ConsignmentEdit.vue?vue&type=script&lang=js&"
export * from "./ConsignmentEdit.vue?vue&type=script&lang=js&"
import style0 from "./ConsignmentEdit.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ConsignmentEdit.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./ConsignmentEdit.vue?vue&type=style&index=2&lang=scss&"
import style3 from "./ConsignmentEdit.vue?vue&type=style&index=3&id=2415cfa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2415cfa6",
  null
  
)

export default component.exports